import { type TransactionLineItem } from '@kalos/kalos-rpc';

export const getLineItemUpdateFieldMask = ({
  original,
  updated,
}: {
  original: TransactionLineItem;
  updated: TransactionLineItem;
}) => {
  const fieldMask: string[] = [];
  if (original.amount !== updated.amount) {
    fieldMask.push('Amount');
  }
  if (original.description !== updated.description) {
    fieldMask.push('Description');
  }
  if (original.ownerId !== updated.ownerId) {
    fieldMask.push('OwnerId');
  }
  if (original.departmentId !== updated.departmentId) {
    fieldMask.push('DepartmentId');
  }
  if (original.costCenterId !== updated.costCenterId) {
    fieldMask.push('CostCenterId');
  }
  if (original.jobId !== updated.jobId) {
    fieldMask.push('JobId');
  }
  if (original.secondaryAmount !== updated.secondaryAmount) {
    fieldMask.push('SecondaryAmount');
  }
  if (original.secondaryAmountNote !== updated.secondaryAmountNote) {
    fieldMask.push('SecondaryAmountNote');
  }
  return fieldMask;
};

export const wasTransactionLineItemUpdated = ({
  original,
  updated,
}: {
  original: TransactionLineItem[];
  updated: TransactionLineItem;
}) => {
  const matchedOriginalLineItem = original.find((oli) => oli.id === updated.id);
  if (!matchedOriginalLineItem) {
    return true;
  }
  return (
    getLineItemUpdateFieldMask({
      original: matchedOriginalLineItem,
      updated,
    }).length !== 0
  );
};
